import SobreNostros from "pages/LandingPages/SobreNosotros/sobrenosotros";

export default function SobreNosotrosPage() {
  return <SobreNostros />;
}
